/**
 * Every value the API writes to journal_entries.source, with a human-readable
 * label. Reports surface these so the owner can see WHAT created a GL line
 * (manual entry, invoice, bank match, import, ...) without opening the entry.
 */
export const JOURNAL_SOURCE_LABELS: Record<string, string> = {
  manual: 'Manual',
  invoice: 'Invoice',
  invoice_payment: 'Invoice payment',
  bank_match: 'Bank match',
  bill: 'Bill',
  bill_payment: 'Bill payment',
  check: 'Check',
  deposit: 'Deposit',
  import: 'Import',
  intercompany: 'Intercompany',
  depreciation: 'Depreciation',
  asset_disposal: 'Asset disposal',
  loan_payment: 'Loan payment',
  loan_origination: 'Loan origination',
  shareholder_loan_payment: 'Shareholder loan',
  shareholder_loan_origination: 'Shareholder loan origination',
  payroll: 'Payroll',
  recurring: 'Recurring',
  year_end_close: 'Year-end close',
  reconciliation_adjustment: 'Recon adjustment',
  inventory_sync: 'Inventory sync',
};

export function journalSourceLabel(source: string): string {
  return JOURNAL_SOURCE_LABELS[source] ?? source;
}
